/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitPolicyAction
*/
export var KitPolicyAction;
(function (KitPolicyAction) {
    KitPolicyAction["KEEP"] = "KEEP";
    KitPolicyAction["OVERWRITE"] = "OVERWRITE";
    KitPolicyAction["IGNORE"] = "IGNORE";
    KitPolicyAction["MERGE"] = "MERGE";
})(KitPolicyAction || (KitPolicyAction = {}));
//# sourceMappingURL=KitPolicyAction.js.map